import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";

const DataTable = ({
  rows,
  columns,
  getRowId,
  rowCount,
  paginationModel,
  onPaginationModelChange,
  pageSizeOptions = [10, 25, 50, 100],
  paginationMode = "client",
  loading = false,
  getRowHeight,
  processRowUpdate,
}) => {

  return (
    <Paper sx={{ height: "calc(80vh - 70px)", width: "100%", mb: "2%", }}>
      <DataGrid

        rows={rows}
        columns={columns}
        {...(getRowId ? { getRowId } : { getRowId: (row) => row._id })}
        rowCount={rowCount}
        paginationModel={paginationModel}
        onPaginationModelChange={onPaginationModelChange}
        paginationMode={paginationMode}
        pageSizeOptions={pageSizeOptions}
        loading={loading}

        {...(getRowHeight ? { getRowHeight } : {})}
        processRowUpdate={processRowUpdate}
        experimentalFeatures={{ newEditingApi: true }}
        sx={{
          position: "relative",
          border: 0,
          "& .MuiDataGrid-row": {
            alignItems: "center",
          },
          "& .MuiDataGrid-columnHeaders": {
            position: "sticky",
            top: 0,
            backgroundColor: "#fff",
            zIndex: 100,
          },
        }}

        slots={{
          noRowsOverlay: () => (
            <div style={{ padding: "20px", textAlign: "center", color: "#666" }}>
              No Data Found
            </div>
          ),
        }}
      />
    </Paper>
  );
};

export default DataTable;
